import { boolean, nativeEnum, number, object, string, ZodIssueCode } from 'zod';
import type { RefinementCtx } from 'zod';

import { IS_REQUIRED, isGreaterThanOrEqualTo } from '@occc-app/lib/constants/validationMessages';
import { Limit_Time_Period } from '@occc/graphql';

const requireLimitWhenEnabled = (
  data: { isEnabled: boolean; limit?: number },
  ctx: RefinementCtx,
) => {
  if (data.isEnabled && (data.limit === undefined || data.limit < 1)) {
    ctx.addIssue({
      code: ZodIssueCode.custom,
      path: ['limit'],
      message: data.limit === undefined ? IS_REQUIRED : isGreaterThanOrEqualTo(1),
    });
  }
};

export const progressPerPeriodLimitSchema = object({
  id: string().optional(),
  isEnabled: boolean(),
  limit: number().optional(),
  timePeriod: nativeEnum(Limit_Time_Period),
}).superRefine(requireLimitWhenEnabled);
